// My Company → "Location compulsory": when ticked, any document with a Location
// field (sales, purchase, store) can't be saved — or posted from its list —
// without one. Off (the default) = everything as before.
// Firebase cost: nothing (reads the company already loaded at login).

export const locationCompulsory = (company) => company?.locationCompulsory === true;

export const LOCATION_REQUIRED_MSG =
  'Select the Location — it is compulsory for this company (Settings → My Company).';

/** True when the tick is on and any of the given location values is empty. */
export const missingLocation = (company, ...locationIds) =>
  locationCompulsory(company) && locationIds.some((v) => !v);

/** Label text with a star when compulsory, e.g. reqLabel(co, 'Location'). */
export const reqLabel = (company, text) => (locationCompulsory(company) ? `${text} *` : text);
